import Card from "../Card/Card";
import Section from "../SectionLayout/Section";
import {
  ANGULAR_ICON,
  BOOTSTRAP_ICON,
  CSS_ICON,
  D3_ICON,
  FIGMA_ICON,
  FIREBASE_ICON,
  GATSBY_ICON,
  GIT_ICON,
  GULP_ICON,
  HTML_ICON,
  JAVASCRIPT_ICON,
  JQUERY_ICON,
  LESS_ICON,
  MATERIAL_ICON,
  NPM_ICON,
  REACT_ICON,
  REDUX_ICON,
  SASS_ICON,
  TYPESCRIPT_ICON,
  VSCODE_ICON,
} from "../Svgs/LanguageSvgs/IconList";
import "./SkillsAndExperience.css";
import workExp from "../../data/workexp.json";

const SkillsAndExperience = () => {
  return (
    <Section title="Skills & Experience">
      <div className="card-wrapper two-col-layout skills-experience">
        <Card title="Skills">
          <div className="showcase">
            <div className="panel">
              <HTML_ICON />
              <CSS_ICON />
              <JAVASCRIPT_ICON />
              <LESS_ICON />
              <SASS_ICON />
            </div>
            <div className="panel">
              <JQUERY_ICON />
              <GULP_ICON />
              <BOOTSTRAP_ICON />
              <MATERIAL_ICON />
            </div>
            <div className="panel">
              <REACT_ICON />
              <GATSBY_ICON />
              <REDUX_ICON />
              <ANGULAR_ICON />
              <TYPESCRIPT_ICON />
              <D3_ICON />
            </div>
            <div className="panel">
              <FIREBASE_ICON />
              <NPM_ICON />
              <GIT_ICON />
              <VSCODE_ICON />
              <FIGMA_ICON />
            </div>
          </div>
        </Card>
        <Card title="Work Experience">
          <ul className="timeline">
            {workExp.map((work, index) => (
              <li key={index}>
                <h4>
                  <a className="logo" href={work.logo.link}>
                    <img
                      src={work.logo.imageURL}
                      alt={work.logo.alt}
                      width={work.logo.width}
                    />
                  </a>
                </h4>
                <small className="text-muted">
                  <em>
                    {work.tenure.from} - {work.tenure.to}. {work.location.city},{" "}
                    {work.location.country}
                  </em>
                </small>
                <ul className="responsibility">
                  {work.responsibilites.map((responsibility, index) => (
                    <li key={index}>
                      <p>{responsibility}</p>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </Card>
      </div>
    </Section>
  );
};

export default SkillsAndExperience;
